import * as React from 'react';
import DemoButtons from './Utiilities/DemoButtons';
import ImageSction1 from "../Assests/Images/Ed365/ImageSection1.png";
import ImageSlider from './Utiilities/ImageSlider';
import Plans from './Utiilities/Plans';
import Accordion from './Utiilities/AccordionItem';
import Lightbox from './Utiilities/Lightbox';
import SpecailButtons from './Utiilities/SpecialButtons';
import Header from './Header and Footer/Header';
import Footer from './Header and Footer/Footer';
import ScrollToTop from './Utiilities/ScrolltoTop';
import G2Badge from './Utiilities/G2Badge';
import TabsWithImage from './Utiilities/TabsWithImage';
import Availability from './Utiilities/Availability';
import OurClients from './Utiilities/OurClients';
import Integration from './Utiilities/Integration';
import { HelmetProvider, Helmet } from "react-helmet-async";

import { useEffect, useState } from 'react';
import GetOfferPage from './Utiilities/GetOfferPage';
import Azuer from './Utiilities/Azuer';
import OverviewCommon from './GlobalMultiple/OverviewCommonCLM';
import CyberSecurity from './Utiilities/demo';
import ComparisonSection from './ComparisonSection';
import CLMClient from './Utiilities/CLMClient';
import OverviewLPCLM365 from './GlobalMultiple/OverviewLPCLM365';
function LPCLM365() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const featuresEndtoEnd = [
        {
            title: "AI Contract Review",
            desc: "Review contracts faster with AI summaries that highlight key clauses, risks, and obligations in simple language. ",
            icon: (<>
                <div class="feature-icon fi-teal"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><path d="M12 8v4l3 3"></path></svg></div></>)
        },
        {
            title: "Clause Risk Detection",
            desc: "Identify risky clauses, missing terms, non-standard language, and areas needing legal review automatically.",
            icon: (
                <>
                    <div class="feature-icon fi-orange"><svg viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg></div></>
            )
        },
        {
            title: "Obligation Identification",
            desc: "Extract obligations, owners, deliverables, timelines, and follow-up actions from signed contracts automatically.",
            icon: (
                <>
                    <div class="feature-icon fi-purple"><svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line></svg></div></>
            )
        },
        {
            title: "Automated Approval Workflows",
            desc: "Route contracts to legal, procurement, finance, and leadership based on contract type and business rules.",
            icon: (<><div class="feature-icon fi-green"><svg viewBox="0 0 24 24"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg></div>
            </>)
        },
        {
            title: "Renewal & Expiry Reminders",
            desc: "Track renewal dates, expiry dates, notice periods, and commercial milestones with proactive automated alerts.",
            icon: (
                <><div class="feature-icon fi-gold"><svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg></div>
                </>
            )
        },
        {
            title: "Contract Dashboards",
            desc: "View contract status, pending approvals, upcoming renewals, obligations, risks, and business-critical terms in one place.",
            icon: (
                <>
                    <div class="feature-icon fi-navy"><svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></div>
                </>
            )
        },
    ];
    const dataIntegration = [
        {
            title: "SharePoint",
            desc: "Secure contract storage, metadata, document history, and access control.",
            img: "https://ik.imagekit.io/zn4au2jftpm5/sharepoint-logo-_cmiWFaZqe.webp"
        },
        {
            title: "Microsoft Teams",
            desc: "Collaborate on approvals, reviews, and follow-ups where your team works.",
            img: "https://ik.imagekit.io/apps365/Apps365/HD/MS%20teams.webp?updatedAt=1762945136977"
        },
        {
            title: "Outlook",
            desc: "Send reminders, approval notifications, and renewal alerts automatically.",
            img: "https://ik.imagekit.io/zn4au2jftpm5/microsoft-outlook-icon-logo_gDHQpwu35.png"
        },
        {
            title: "Power Automate",
            desc: "Automate approvals, routing, escalations, and lifecycle events.",
            img: "https://ik.imagekit.io/zn4au2jftpm5/CLM365/Power%20Automate%20(1)_eXEyQVXbrh.png?updatedAt=1735914125187"
        },
        {
            title: "M365 Security",
            desc: "Role-based access, audit trails, and governance aligned to your environment.",
            img: "https://ik.imagekit.io/zn4au2jftpm5/Microsoft_logo.svg_pVkFqFdkP.png?updatedAt=1726464369360"
        },
    ];
    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const dynamicImages = [
        'https://ik.imagekit.io/zn4au2jftpm5/hr365/LOGO/Client%20logos1_RPf_AeXggA.png?updatedAt=1700627745162',
        'https://ik.imagekit.io/zn4au2jftpm5/hr365/LOGO/Client%20logos2_fZX_JD70Nu.png?updatedAt=1700627744112',
        // Add more image URLs as needed
    ];
    const planData = [
        {
            name: 'Standard',
            price: '$49',
            sup: '99',
            text: 'Standard Plan Features',
            textY: 'per month, billed yearly',
            features: ['Minimum 5 users', 'Max 30 contracts / year', 'Unlimited support through email only', 'Integrates with Microsoft 365', 'Data stays within Microsoft 365', 'Contract Authoring', 'One level approval flow', 'Negotiation', 'Execution'],

        },
        {
            name: 'Plus',
            price: '$69',
            sup: '99',
            textY: 'per month, billed yearly',
            text: 'Everything in Standard and...',
            features: ['Minimum 5 users', 'Max 60 contracts / year', 'Unlimited support through email only', 'Free updates via MS store', 'Mobile responsive', 'Limited Approval Workflows', 'Draft, Negotiate & Execute', 'Contract Repository', 'Clause Library', 'Reports'],
        },
        {
            name: 'Premium',
            price: '$89',
            sup: '99',
            textY: 'per month, billed yearly',
            text: 'Everything in Plus, and...',
            features: ['Minimum 5 users', 'Max 120 contracts / year', 'Additional 10 contracts/month at $89.99', 'Unlimited support includes live chat', 'Free updates with support', '3 Contract templates', 'Two Level Approvals', 'Alerts & Notifications', 'Version control', 'Amendment', 'Renewals', 'Advance Search Capabilities', 'Advance Reporting', 'Role based Security', 'Add Documents'],
        },
        {
            name: 'Enterprise',
            price: '$129',
            sup: '99',
            textY: 'per month, billed yearly',
            text: 'Everything in Premium and...',
            features: ['Minimum 5 users', 'Max 240 contracts / year', 'Additional 10 contracts/month at $129.99', 'Unlimited support with screen sharing', '7 Contract templates', 'Multilevel Approvals', 'Obligation Management', 'Import Existing Contracts', 'AI based Obligations', 'Audit Trail', 'Activity Log', 'Add Documents', 'Risk Assessment', 'Approval through Emails', 'Digital Signature', 'Dashboard', 'MS Teams & Outlook App'],
        },
    ];
    const data = [

        {
            heading: 'Assets depreciation – calculation &amp; reporting'
            ,
            imageUrl: 'https://ik.imagekit.io/zn4au2jftpm5/AMP_SS/Depreciation_details_QEJu2iBIX.png?ik-sdk-version=javascript-1.4.3&updatedAt=1664186732101',
        },
        {
            heading: 'Bar code &amp; QR code',
            imageUrl: 'https://ik.imagekit.io/zn4au2jftpm5/AMP_SS/bar_code_O1_82R9Ki.png?ik-sdk-version=javascript-1.4.3&updatedAt=1664169542304',
        },
        {

            heading: 'Assets Report',
            imageUrl: 'https://ik.imagekit.io/zn4au2jftpm5/AMP_SS/bar_code_O1_82R9Ki.png?ik-sdk-version=javascript-1.4.3&updatedAt=1664169542304',
        },
        {

            heading: 'Connect Asset 365 with your other apps',
            imageUrl: 'https://ik.imagekit.io/zn4au2jftpm5/hr365/SPFxEDP/powerplatformtoolset_ReRdfzh4N.png?updatedAt=1700466299384',
        },


        // Add more objects as needed
    ];
    const accordionItems = [
        {
            title: '1. Can SharePoint be used for contract management?', content: `Yes. SharePoint can be used as the foundation for contract management. CLM 365 enhances SharePoint with workflows, metadata, AI automation, contract dashboards, renewal alerts, and obligation tracking to turn it into a complete CLM platform.`
        },
        {
            title: `2. How does a CLM 365 App help in managing contracts on the go?`, content: `A CLM 365 App allows users to access, review, and manage contracts directly from their mobile devices. This flexibility ensures that key stakeholders can approve, amend, or monitor contracts anytime, anywhere, which accelerates the contract lifecycle and enhances collaboration. `
        },
        {
            title: `3. Is CLM 365 built on SharePoint?`,
            content: `Yes. CLM 365 is designed for organizations that use Microsoft 365 and SharePoint for document management, collaboration, and security. It works natively inside your existing environment.`
        }, {
            title: '4. How does Microsoft CLM 365 Software integrate with other Microsoft products?',
            content: `Microsoft CLM 365 Software is designed to integrate smoothly with other Microsoft products, such as Office 365, Dynamics 365, and Azure. This integration allows for a unified platform where contracts can be managed alongside other business processes, enhancing productivity and ensuring data consistency across systems.`
        },
        {
            title: '5. Does CLM 365 include AI?',
            content: `Yes. CLM 365 includes AI capabilities for contract creation, clause risk detection, summaries, obligation identification, and commercial term tracking — all within Microsoft 365.`
        },
        {
            title: '6. Can CLM 365 send renewal reminders?',
            content: `Yes. CLM 365 tracks renewal dates, expiry dates, notice periods, and commercial review dates with automated reminders delivered through Outlook and Teams.`
        },
        {
            title: '7. Who should use SharePoint contract management software?',
            content: `CLM 365 is ideal for legal, procurement, sales, finance, and operations teams that need to manage contracts securely inside Microsoft 365 without learning a new platform.`
        }
    ];
    const tabs = [
        {
            id: 6, title: 'AI Powered ', Heading: 'Simplify Contract Management With AI', content: (
                <ul>
                    <li>
                        Instantly use AI to extract key terms, obligations, and risks from any contract for actionable insights in seconds.
                    </li>
                    <li>
                        Leverage AI agent to retrieve comprehensive counterparty information, including contact details, contract history, and compliance records.
                    </li>
                    <li>
                        Manage, update, and collaborate on contracts directly within Outlook, Teams, or Word.
                    </li>
                    <li>
                        Use Microsoft Copilot AI to summarize contracts, suggest edits, and highlight essential terms within your workflow.
                    </li>
                    <li id='Comparison'>
                        Link related agreements under a primary contract for better visibility and streamlined management.
                    </li>

                </ul>
            ),
            image: 'https://ik.imagekit.io/apps365/Lp-pages/CLM-ai-image.png'
        },
        {
            id: 1, title: 'Microsoft Ecosystem', Heading: 'Effortless Integration with Microsoft Ecosystem: CLM 365 System', content: (
                <ul>
                    <li>
                        Maximize your existing Microsoft ecosystem by incorporating our advanced CLM 365 system.
                    </li>
                    <li>
                        This intuitive, cloud-based software integrates smoothly with Microsoft 365, boosting your productivity and efficiency.
                    </li>
                    <li>
                        Utilizing the power of SharePoint and functioning as a Microsoft Teams app, it offers a centralized hub for all your CLM 365 needs.
                    </li>
                    <li>
                        Seamless synchronization with Microsoft Outlook for streamlined contract tracking and notifications.
                    </li>
                </ul>
            ),
            image: 'https://ik.imagekit.io/apps365/Lp-pages/CLM%202.webp'
        },
        {
            id: 2, title: 'Contract Operations', Heading: 'Streamlined Contract Operations: SharePoint CLM 365 app', content: (
                <ul>
                    <li>
                        Microsoft CLM 365 software simplifies the entire contract lifecycle, integrating seamlessly with DocuSign, e-sign, and your Microsoft environment.
                    </li>
                    <li>
                        SharePoint CLM 365 provides exceptional security, control, and visibility.
                    </li>
                    <li>
                        It features smart draft-to-signature workflows, customizable scenarios, and automated alerts for timely obligations.
                    </li>
                    <li>
                        Enhanced collaboration through real-time updates and shared access within Microsoft Teams.
                    </li>
                    <li>
                      CLM 365 lets users redline contracts, track changes, add comments, and manage versions directly in Microsoft Word.
                    </li>
                </ul>
            ), image: 'https://ik.imagekit.io/apps365/Lp-pages/CLM%203.webp'
        },
        {
            id: 3, title: 'User-centered', Heading: 'User-centered Approach to CLM 365 tool Design', content: (
                <ul>
                    <li>
                        Using Microsoft Fluent UI, our CLM 365 application provides an intuitive interface for easy navigation and minimal learning curve.
                    </li>
                    <li>
                        Enhanced by AI, it offers dynamic contract interactions and an adaptable workflow.
                    </li>
                    <li>
                        AI-driven document comparison ensures precise tracking of changes, improving accuracy and efficiency in reviewing modifications.
                    </li>
                    <li>
                        Personalized user settings allow customization of dashboards and notifications to suit individual preferences.
                    </li>
                </ul>
            ), image: 'https://ik.imagekit.io/zn4au2jftpm5/Apps365/Teams/CLM%20365%20teams_yFI8NzGjap.png?updatedAt=1725450649581'
        },
        {
            id: 4, title: 'Agreements', Heading: 'Microsoft CLM 365 with simplified Agreements', content: (
                <ul>
                    <li>
                        CLM 365 software is your comprehensive toolkit for handling critical documents such as supplier agreements, customer contracts, and employment terms.
                    </li>
                    <li>It ensures seamless creation, sharing, and organization of these contracts to streamline business operations.</li>
                    <li>Think of it like organizing a large-scale party, where you handle invitations, meals, and music coordination, but for your business agreements.</li>
                </ul>
            ),
            image: 'https://ik.imagekit.io/apps365/Lp-pages/CLM%203.webp'
        },
        {
            id: 5, title: 'Security', Heading: 'Enterprise-Grade Security and Compliance: CLM 365 Software', content: (
                <ul>
                    <li>
                        Detailed Audit Trails
                    </li>
                    <li>
                        Precision Access Control
                    </li>
                    <li>
                        Tenant-Specific Central Repository
                    </li>
                    <li>
                        Flexible Custom Reporting
                    </li>
                    <li>
                        Proactive Alerts and AI-Driven Notifications
                    </li>
                    <li>
                        Top-Tier Security and Privacy Standards
                    </li>
                    <li>
                        Built-in Digital Signatures
                    </li>
                </ul>
            ),
            image: 'https://ik.imagekit.io/zn4au2jftpm5/Apps365/Teams/CLM%20365%20teams_yFI8NzGjap.png?updatedAt=1725450649581'
        },


    ];
    const [isLightboxOpen, setLightboxOpen] = React.useState(false);
    const [selectedImageUrl, setSelectedImageUrl] = React.useState('');

    const openLightbox = (imageUrl) => {
        setSelectedImageUrl(imageUrl);
        setLightboxOpen(true);
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
    };
    const features = [
        "Built inside Microsoft 365",
        "AI contract creation & review",
        "Automated approval workflows",
        "Renewal & expiry reminders",
        "Clause risk detection",
    ]
    const CheckIcon = () => (
        <svg
            viewBox="0 0 16 16"
            fill="none"
            stroke="#333"
            strokeWidth="2"
            strokeLinecap="round"
        >
            <polyline points="2,8 6,12 14,4" />
        </svg>
    );

    const challenges = [
        "Contracts scattered across folders and departments",
        "Multiple versions of the same agreement causing confusion",
        "Manual follow-ups for approvals slowing deals down",
        "Missed renewal dates and costly notice periods",
        "No lifecycle visibility from request to renewal",
    ];

    const solutions = [
        "Structured contract repository with metadata",
        "AI-powered clause risk and obligation detection",
        "Automated approval workflows and routing",
        "Automated renewal and expiry reminders",
        "Dashboards for full lifecycle visibility",
    ];
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Effortless CLM 365 – Simplified for Your Business</title>
                    <meta name="description" content="Centralize, track, and manage contracts effortlessly with eSign, custom workflows, and real-time tracking—integrated seamlessly with Microsoft Teams & SharePoint." />
                </Helmet>
                <ScrollToTop />
                <Header isComparison={true} />
                <div className='HR_panel'>
                    <div className="HR_FlexCenterSpcBetween HR_ParentSection1" >
                        <div className="hero-wrapper">
                            <span className="hero-badge">SharePoint Contract Management</span>

                            <h1 className="hero-heading">
                                AI-Powered Contract
                                <br />
                                Management <span className="accent">Inside

                                    Microsoft 365</span>
                            </h1>

                            <p className="hero-desc">
                                CLM 365 transforms SharePoint from a document library into a complete
                                contract lifecycle management platform — with AI agents, automated
                                workflows, clause risk detection, and renewal reminders.
                            </p>

                            <div className="hero-cta">
                                <DemoButtons isreverse={true}
                                    demobtnText="Request a Demo" trailbtnText="Explore Features" />
                            </div>

                            <div className="hero-features">
                                {features.map((feature) => (
                                    <span key={feature} className="feature-pill">
                                        <CheckIcon />
                                        {feature}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className='HR_Section1RightSide CLMHerosectionRight'>
                            <div className="RightdemoForm">
                                <div className="FormFieldStyles">
                                    <h3>Book Your Free Demo</h3>
                                    <p>See CLM 365 in action — no commitment required.</p>
                                    <DemoButtons CLM365demoForm={true} />
                                </div>

                            </div>
                            {/* <img alt='MainImage' src={"https://ik.imagekit.io/zn4au2jftpm5/hr365/random-images/20944145__1_-removebg-preview%20(1)_8HExemHEKq.png?updatedAt=1708084034004"} /> */}
                        </div>
                    </div>
                </div>
                {/* <GetOfferPage Type="Image"/> */}


                <div>
                    <G2Badge
                    // heading="Now CLM 365 - Contract Management App is Available on Microsoft Teams"
                    // videoUrl="https://www.youtube.com/watch?v=jIfazWcHpwI"
                    // imageUrl="https://ik.imagekit.io/zn4au2jftpm5/Apps365/Teams/CLM%20365%20teams_yFI8NzGjap.png?updatedAt=1725450649581"
                    />

                    <section className="sharepoint-store">
                        <div className="sharepoint-container">
                            <div className="sharepoint-header">
                                <h2 className='HR_heading'>
                                    SharePoint Stores Contracts. CLM 365 with AI Simplifies Contracts 
                                </h2>

                                <p>
                                    Many teams already store contracts in SharePoint. But storage
                                    alone doesn't solve contract management.
                                </p>
                            </div>

                            <div className="sharepoint-content">
                                <div className="sharepoint-left">
                                    {challenges.map((item, index) => (
                                        <div className="challenge-card" key={index}>
                                            <div className="challenge-icon">
                                                <div class="pain-icon"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg></div>
                                            </div>

                                            <span>{item}</span>
                                        </div>
                                    ))}
                                </div>

                                <div className="sharepoint-right">
                                    <h3>
                                        CLM 365 Adds the Structure, AI, and Automation Your
                                        Contracts Need
                                    </h3>

                                    <p>
                                        Instead of SharePoint as a storage location, CLM 365 adds
                                        metadata, AI extraction, approval workflows, renewal alerts,
                                        obligation tracking, and secure collaboration.
                                    </p>

                                    <ul>
                                        {solutions.map((item, index) => (
                                            <li key={index}>
                                                <div class="solution-check"><svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg></div>
                                                <span>{item}</span>
                                            </li>
                                        ))}
                                    </ul>

                                    <div className='HowtoworkBtn' >
                                        <DemoButtons LMS365="LMS365"
                                            demobtnText="See How It Works" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="contract-end-to-end">
                        <div className="contract-container">
                            <div className="contract-heading">
                                <h2 className='HR_heading'>Everything You Need to Manage Contracts End-to-End</h2>

                                <p>
                                    Built inside Microsoft 365 so your team never has to leave
                                    the environment they trust.
                                </p>
                            </div>

                            <div className="contract-grid">
                                {featuresEndtoEnd.map((item, index) => (
                                    <div className="contract-card" key={index}>
                                        <div className="contract-icon">
                                            {typeof item.icon === "string" ? (
                                                <img src={item.icon} alt={item.title} />
                                            ) : (
                                                item.icon
                                            )}
                                        </div>

                                        <h3>{item.title}</h3>
                                        <p>{item.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                    <OverviewLPCLM365 subHeading="AI Contract Management Agents Built into CLM 365" MainHeading="CLM 365 in One Place — MS Teams, SharePoint, Outlook, Copilot and Agentic AI " />


                </div>
                <div id="features" className="IdChanges"></div>
                <div>
                    <TabsWithImage tabs={tabs} />
                </div>

                <ComparisonSection />

                <div id="client" className="IdChanges"></div>
                <div className='HR_whitesection'>
                    <h2 className='HR_heading HR_MT' >Our Clients
                    </h2>

                    <div className='HR_MT'>
                        <CLMClient />
                    </div>
                    {/* <div style={{ background: "none", padding: "0vw 6vw 2vw -0.9vw" }}>
                        <h2 class="et-integration-title">Boost Productivity with Seamless Integrations</h2>
                        <p class="et-integration-subtitle">
                            Easily set up, customize, and manage the cloud-based business expense tracker with powerful tools to handle expense and finances of the organization.
                        </p>

                        <div class="et-integration-grid">
                            <div class="et-integration-card">
                                <div class="et-icon-space"><img
                                    style={{ width: "100%" }}
                                    alt="MainImage"
                                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/Power%20Automate%20(1)_eXEyQVXbrh.png?updatedAt=1735914125187"
                                />  </div>
                                <h3 class="et-card-title">Power Automate</h3>
                                <p class="et-card-description">
                                    Save time by automating ticket updates, notifications, and approvals for smoother support management.
                                </p>
                            </div>

                            <div class="et-integration-card">
                                <div class="et-icon-space"><img
                                    style={{ width: "100%" }}
                                    alt="MainImage"
                                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/Power%20Bi%20(1)_Kds_Hz7QcQ.png?updatedAt=1735914124948"
                                /></div>
                                <h3 class="et-card-title">Power BI</h3>
                                <p class="et-card-description">
                                    Generate clear and detailed reports to better analyse support performance and make informed decisions.
                                </p>
                            </div>

                            <div class="et-integration-card">
                                <div class="et-icon-space"><img
                                    style={{ width: "100%" }}
                                    alt="MainImage"
                                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/power%20apps%20(1)_fKJEyRsAdu.png?updatedAt=1735914124951"
                                /></div>
                                <h3 class="et-card-title">Power Apps</h3>
                                <p class="et-card-description">
                                    Use AI chatbots to instantly answer common customer support queries or provide ticket updates.
                                </p>
                            </div>

                            <div class="et-integration-card">
                                <div class="et-icon-space"><img
                                    style={{ width: "100%" }}
                                    alt="MainImage"
                                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/Power%20virtual%20Agent%20(1)_F7DLaFcFoe.png?updatedAt=1735914125177"
                                /></div>
                                <h3 class="et-card-title">Power Virtual Agent</h3>
                                <p class="et-card-description">
                                    Build custom apps to enhance ticketing workflows and integrate seamlessly with Expense 365.
                                </p>
                            </div>
                        </div>
                    </div> */}
                    <section className="m365-section">
                        <div className="m365-container">
                            <h2 className="HR_heading">
                                Built for Your Microsoft 365 Ecosystem
                            </h2>

                            <p className="m365-subtitle">
                                CLM 365 plugs directly into the tools your team already uses

                                every day.
                            </p>

                            <div className="m365-grid">
                                {dataIntegration.map((item, index) => (
                                    <div className="m365-card" key={index}>
                                        <div className="m365-icon-wrap">
                                            <img
                                                src={item.img}
                                                alt={item.title}
                                                className="m365-icon"
                                            />
                                        </div>

                                        <h3>{item.title}</h3>

                                        <p>{item.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                </div>  <div id="integration" className="IdChangesIntegration"></div>
                <div className='cybersection' >
                    <CyberSecurity />
                </div>
                <div className="IdChangesIntegration"></div>


                <div className='HR_MT HR_whitesection'>
                    <div className="HR_MT">
                        <div>
                            <h2 className='HR_heading HR_MT' id="pricing">CLM 365 - Contract Management Plans
                            </h2>
                            <Plans plans={planData} isStandardPlan={false} appName="CLM 365 - Contract Management" />
                        </div>
                    </div>
                </div>







                <Azuer userCount={"50+"} />
                <span className='privacytext'></span>

                <section className="manage-footer-content">
                    <div className="manage-footer-container">
                        <h2 className="manage-footer-title">
                            Ready to Manage Contracts Inside SharePoint?
                        </h2>

                        <p className="manage-footer-description">
                            Move from scattered contract files to a structured, AI-powered
                            contract management platform — built inside Microsoft 365.
                        </p>
                        <div style={{ display: "flex", justifyContent: "center", padding: "2vw 0vw" }}>
                            <DemoButtons isreverse={true}
                                demobtnText="Request a Demo" trailbtnText="Talk to Sales" />
                        </div>
                    </div>
                </section>
                <div id="faq" className="IdChangesIntegration"></div>
                <div className='HR_FAQ' >

                    <div>
                        <h3 className='HR_faq'>Frequently Asked Questions</h3>
                        <Accordion items={accordionItems} />
                    </div>


                </div>

                <Footer />
            </HelmetProvider>
        </>
    )
}
export default LPCLM365;